import React, { memo } from 'react';
import PropTypes from 'prop-types';

import PaymentMethod from './Steps/PaymentMethod';
import PersonalInformation from './Steps/PersonalInformation';
import TaxForm from './Steps/TaxForm';
import { TAX_FORM_STEP } from './constants';

const TAX_STEP = {
  [TAX_FORM_STEP.PERSONAL_INFORMATION]: PersonalInformation,
  [TAX_FORM_STEP.PAYMENT_METHOD]: PaymentMethod,
};

const TaxEntryForm = ({ currentStep, userData, currentTaxForm }) => {
  const TaxStep = TAX_STEP[currentStep];

  if (TaxStep) {
    return <TaxStep userData={userData} />;
  }

  if (currentTaxForm) {
    const {
      jurisdiction_name: jurisdictionName,
      is_submitted: isSubmitted,
      is_federal: isFederal,
      is_blocking: isBlocking,
      ...props
    } = currentTaxForm;

    return (
      <TaxForm
        jurisdictionName={jurisdictionName}
        isSubmitted={isSubmitted}
        isFederal={isFederal}
        isBlocking={isBlocking}
        {...props}
      />
    );
  }

  return null;
};

TaxEntryForm.propTypes = {
  currentStep: PropTypes.string.isRequired,
  footerButtonText: PropTypes.string,
};

export default memo(TaxEntryForm);
